import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Tree = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Tree" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M10.4385 2.4944C11.2619 1.46118 12.8673 1.49596 13.6387 2.59792L18.6368 9.73854C19.4678 10.9266 18.5991 12.4628 17.2862 12.5237L21.3203 18.2864C22.3716 19.7895 21.0141 21.7967 19.2276 21.3801L12.9961 19.926C12.9979 19.9504 13 19.9755 13 20.0003V22.0003C12.9997 22.5522 12.552 23.0001 12 23.0003C11.4481 23.0001 11.0003 22.5522 11 22.0003V20.0003C11 19.9755 11.0012 19.9504 11.003 19.926L4.7725 21.3801C2.98599 21.7967 1.62837 19.7895 2.67972 18.2864L6.71195 12.5237C5.39996 12.4616 4.53253 10.9261 5.36332 9.73854L10.3614 2.59792L10.4385 2.4944ZM7.28617 10.4768C8.59931 10.5377 9.46842 12.0749 8.63675 13.263L4.3184 19.4329L11.545 17.7464C11.8438 17.6767 12.1553 17.6767 12.4541 17.7464L19.6817 19.4329L15.3633 13.263C14.532 12.0754 15.3998 10.539 16.712 10.4768L12 3.7444L7.28617 10.4768Z" fill="#000" />
  </StyledIcon>
));

Tree.displayName = 'Tree';

export { Tree };
